export const USER_PROFILE_REQUEST = 'USER_PROFILE_REQUEST';
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_FAILURE = 'USER_PROFILE_FAILURE';

export const USER_WHEELS_REQUEST = 'USER_WHEELS_REQUEST';
export const USER_WHEELS_SUCCESS = 'USER_WHEELS_SUCCESS';
export const USER_WHEELS_FAILURE = 'USER_WHEELS_FAILURE';

export const USER_PUBLIC_WHEELS_REQUEST = 'USER_PUBLIC_WHEELS_REQUEST';
export const USER_PUBLIC_WHEELS_SUCCESS = 'USER_PUBLIC_WHEELS_SUCCESS';
export const USER_PUBLIC_WHEELS_FAILURE = 'USER_PUBLIC_WHEELS_FAILURE';

export const USER_PRIVATE_WHEELS_REQUEST = 'USER_PRIVATE_WHEELS_REQUEST';
export const USER_PRIVATE_WHEELS_SUCCESS = 'USER_PRIVATE_WHEELS_SUCCESS';
export const USER_PRIVATE_WHEELS_FAILURE = 'USER_PRIVATE_WHEELS_FAILURE';

export const USER_CLONED_WHEELS_REQUEST = 'USER_CLONED_WHEELS_REQUEST';
export const USER_CLONED_WHEELS_SUCCESS = 'USER_CLONED_WHEELS_SUCCESS';
export const USER_CLONED_WHEELS_FAILURE = 'USER_CLONED_WHEELS_FAILURE';

export const GET_USER_PRIMARY_WHEEL_REQUEST = 'GET_USER_PRIMARY_WHEEL_REQUEST';
export const GET_USER_PRIMARY_WHEEL_SUCCESS = 'GET_USER_PRIMARY_WHEEL_SUCCESS';
export const GET_USER_PRIMARY_WHEEL_FAILURE = 'GET_USER_PRIMARY_WHEEL_FAILURE';

export const ADD_USER_WHEEL_SUCCESS = 'ADD_USER_WHEEL_SUCCESS';

export const REMOVE_USER_WHEEL_SUCCESS = 'REMOVE_USER_WHEEL_SUCCESS';

export const EDIT_USER_WHEEL_SUCCESS = 'EDIT_USER_WHEEL_SUCCESS';
export const MAKE_WHEEL_PRIMARY = 'MAKE_WHEEL_PRIMARY';
export const MAKE_WHEEL_PUBLIC = 'MAKE_WHEEL_PUBLIC';
export const MAKE_WHEEL_PRIVATE = 'MAKE_WHEEL_PRIVATE';

export const EDIT_USER_PROFILE_SUCCESS = 'EDIT_USER_PROFILE_SUCCESS';

export const ADD_CATEGORY_COLOR = 'ADD_CATEGORY_COLOR';
export const RESET_CATEGORY_COLORS = 'RESET_CATEGORY_COLORS';

export const ADD_PENDING_WHEEL = 'ADD_PENDING_WHEEL';
export const REMOVE_PENDING_WHEEL = 'REMOVE_PENDING_WHEEL';
export const UPDATE_PENDING_WHEEL = 'UPDATE_PENDING_WHEEL';

export const ADD_COLOR = 'ADD_COLOR';
export const REMOVE_COLOR = 'REMOVE_COLOR';
export const UPDATE_COLOR = 'UPDATE_COLOR';

export const ADD_GRADIENT_COLOR = 'ADD_GRADIENT_COLOR';
export const REMOVE_GRADIENT_COLOR = 'REMOVE_GRADIENT_COLOR';
export const UPDATE_GRADIENT_COLOR = 'UPDATE_GRADIENT_COLOR';

export const LOGOUT = 'LOGOUT';

export const ADD_CUSTOM_COLOR_SUCCESS = 'ADD_CUSTOM_COLOR_SUCCESS';
export const ADD_CUSTOM_COLOR_FAILURE = 'ADD_CUSTOM_COLOR_FAILURE';

export const EDIT_CUSTOM_COLOR_SUCCESS = 'EDIT_CUSTOM_COLOR_SUCCESS';
export const EDIT_CUSTOM_COLOR_FAILURE = 'EDIT_CUSTOM_COLOR_FAILURE';

export const DELETE_CUSTOM_COLOR_SUCCESS = 'DELETE_CUSTOM_COLOR_SUCCESS';
export const DELETE_CUSTOM_COLOR_FAILURE = 'DELETE_CUSTOM_COLOR_FAILURE';

export const SET_MY_COLORS = 'SET_MY_COLORS';

export const REFERRAL_AMBASSADOR_REQUEST = 'REFERRAL_AMBASSADOR_REQUEST';
export const REFERRAL_AMBASSADOR_SUCCESS = 'REFERRAL_AMBASSADOR_SUCCESS';
export const REFERRAL_AMBASSADOR_FAILURE = 'REFERRAL_AMBASSADOR_FAILURE';

export const REFERRAL_BT_REQUEST = 'REFERRAL_BT_REQUEST';
export const REFERRAL_BT_SUCCESS = 'REFERRAL_BT_SUCCESS';
export const REFERRAL_BT_FAILURE = 'REFERRAL_BT_FAILURE';

export const REFERRAL_DIRECT_REQUEST = 'REFERRAL_DIRECT_REQUEST';
export const REFERRAL_DIRECT_SUCCESS = 'REFERRAL_DIRECT_SUCCESS';
export const REFERRAL_DIRECT_FAILURE = 'REFERRAL_DIRECT_FAILURE';

export const ANALYTICS_REQUEST = 'ANALYTICS_REQUEST';
export const ANALYTICS_SUCCESS = 'ANALYTICS_SUCCESS';
export const ANALYTICS_FAILURE = 'ANALYTICS_FAILURE';

export const TOGGLE_SEGMENT_SETTINGS = 'TOGGLE_SEGMENT_SETTINGS';
export const BG_WALLPAPERS_REQUEST = 'BG_WALLPAPERS_REQUEST';
export const BG_WALLPAPERS_SUCCESS = 'BG_WALLPAPERS_SUCCESS';
export const BG_WALLPAPERS_FAILURE = 'BG_WALLPAPERS_FAILURE';

export const SET_WALLPAPER_TRANSPARENCY = 'SET_WALLPAPER_TRANSPARENCY';
export const SET_WALLPAPER_RESIZING = 'SET_WALLPAPER_RESIZING';
export const SET_WALLPAPER_OVERLAY_COLOR = 'SET_WALLPAPER_OVERLAY_COLOR';
export const SET_BG_WALLPAPER = 'SET_BG_WALLPAPER';
export const SET_BG_GRADIENT = 'SET_BG_GRADIENT';
export const SET_IS_PATTERN = 'SET_IS_PATTERN';
export const SET_SEGMENT_BG_COLOR = 'SET_SEGMENT_BG_COLOR';
export const SET_CURRENT_BG = 'SET_CURRENT_BG';
export const SET_SELECTED_COLOR_TYPE = 'SET_SELECTED_COLOR_TYPE';
export const SET_PATTERN_COLOR = 'SET_PATTERN_COLOR';

export const SET_TITLE = 'SET_TITLE';
export const SET_SUB_TITLE = 'SET_SUB_TITLE';

export const UPDATE_WALLPAPER_INITAL_STATE = 'UPDATE_WALLPAPER_INITAL_STATE';

export const SET_CHECKBOX_LINKED_WHEEL = 'SET_CHECKBOX_LINKED_WHEEL';

export const SET_REPORT_MODAL_OPEN = 'SET_REPORT_MODAL_OPEN';
export const SET_REPORT_INSTANCE = 'SET_REPORT_INSTANCE';
export const SET_REPORT_LOCATION = 'SET_REPORT_LOCATION';

export const RESET_WHEEL_BG_TO_INITIAL_STATE = 'RESET_WHEEL_BG_TO_INITIAL_STATE';

export const SUBSCRIPTION_REQUEST = "SUBSCRIPTION_REQUEST";
export const SUBSCRIPTION_SUCCESS = "SUBSCRIPTION_SUCCESS";
export const SUBSCRIPTION_FAILURE = "SUBSCRIPTION_FAILURE";